import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {FirebaseAppProvider} from 'reactfire';
import firebaseConfig from './firebase-config';

ReactDOM.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <Suspense fallback={<div className="height"><div className="cargando allpage"></div></div>}>
        <App />
      </Suspense>
    </FirebaseAppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);